"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isControlEntityLike = exports.ControlEntity = exports.ControlEntityClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DeviceEnabledType_1 = require("./Device/DeviceEnabledType");
exports.ControlEntityClassName = 'ControlEntity';
class ControlEntity extends DeviceEnabledType_1.DeviceEnabledType {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.ControlEntityClassName)
            throw new Error(`Tried to create a ${exports.ControlEntityClassName} from a ${ob.type} object!`);
        super(exports.ControlEntityClassName, { ...ob });
        this.type = ob.type ?? exports.ControlEntityClassName;
        this.status = ob.status ?? null;
        this.on = ob.on ?? false;
        this.batteryPercentage = ob.batteryPercentage ?? null;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? null;
        this.rssi = ob.rssi ?? null;
        this.sf = ob.sf ?? null;
        this.snr = ob.snr ?? null;
        this.fCnt = ob.fCnt ?? null;
        this.deviceEui = ob.deviceEui ?? null;
        this.gatewayEui = ob.gatewayEui ?? null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            status: {
                label: 'Status',
                type: 'Boolean',
                editable: false,
            },
            on: {
                label: 'On',
                type: 'Boolean',
                editable: true,
                required: true,
            },
        };
    }
}
exports.ControlEntity = ControlEntity;
const isControlEntityLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.ControlEntityClassName;
};
exports.isControlEntityLike = isControlEntityLike;
